<div class="wizard-nav">
  <div class="wizard-step">
    @for (step of steps; track step; let i = $index; let last = $last) {
      <div
        class="step"
        [ngClass]="{ active: i == currentStep, completed: i < currentStep }"
      >
        <div class="step-number">
          <span class="number">{{ i + 1 }}</span>
          <span class="icon"
            ><fa-icon [icon]="['fas', 'check']"></fa-icon
          ></span>
        </div>
        <div class="step-title">{{ step }}</div>
      </div>
      @if (!last) {
        <div class="link"></div>
      }
    }
  </div>

  <div class="step-title">
    <h2>{{ steps[currentStep] }}</h2>
  </div>
</div>
